import * as types from '../../actions/ActionTypes';

export const initialState = {
  favorites: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FILL_FAVORITES:
      return {
        ...state,
        favorites: action.favorites,
      };
    case types.ADD_FAVORITES:
      return {
        ...state,
        favorites: [...state.favorites, action.favorites],
      };
    case types.REMOVE_FAVORITES:
      return {
        ...state,
        favorites: state.favorites.filter((favorite) => favorite.id !== action.favoriteId),
      };
    default:
      return state;
  }
}
